export const closeAll = (payload) => ({
  type: 'CLOSE_ALL',
  payload
});

export const activeLogin = () => ({
  type: 'ACTIVE_LOGIN'
});
